import { gql } from '@apollo/client'

import { MENU_CURATION_TASK_LIST_FRAGMENT } from '../fragments'

const MENU_CURATION_TASKS_QUERY = gql`
  query menuCurationTasks(
    $filters: MenuCurationTaskFiltersInput!
    $pagination: PaginationInput!
    $sorters: MenuCurationTaskSortersInput!
  ) {
    menuCurationTasks(
      filters: $filters
      pagination: $pagination
      sorters: $sorters
    ) {
      total
      result {
        ...MenuCurationTaskListFragment
      }
    }
  }
  ${MENU_CURATION_TASK_LIST_FRAGMENT}
`

export default MENU_CURATION_TASKS_QUERY
